import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "auth-wrapper-inner columns is-gapless" }
const _hoisted_2 = { class: "column is-4" }
const _hoisted_3 = { class: "hero is-fullheight is-white" }
const _hoisted_4 = { class: "hero-body" }
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { class: "columns" }
const _hoisted_7 = { class: "column is-12" }
const _hoisted_8 = { class: "auth-form-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ResetForm = _resolveComponent("ResetForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"column login-column is-8 h-hidden-mobile h-hidden-tablet-p hero-banner\" data-v-399f02a0><div class=\"hero login-hero is-fullheight is-app-grey\" data-v-399f02a0><div class=\"hero-body\" data-v-399f02a0><div class=\"columns\" data-v-399f02a0></div></div><div class=\"hero-footer\" data-v-399f02a0><p class=\"has-text-centered\" data-v-399f02a0></p></div></div></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "hero-heading" }, null, -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "auth-content" }, [
                  _createElementVNode("h2", null, "Set a new password."),
                  _createElementVNode("p", null, "Please enter password and confirm password")
                ], -1)),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_ResetForm)
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}